import { useQuery } from "@tanstack/react-query"
import { useApi } from "../../../../hooks/useApi"

const useTagGroups = () => {
  const { scientApi } = useApi()

  return useQuery({
    queryKey: ["tagGroups"],
    queryFn: () => scientApi.tags.getGroups(),
    staleTime: 60_000,
  })
}

export default useTagGroups
